<h6 style="margin-top: 5px">{{ project }}</h6>

<usimweb-plot
  divId="densityContainer"
  (initialized)="onInitialized()"
  [data]="densityViscoChart"
  [layout]="densityViscoLayout"
></usimweb-plot>
